import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { 
    POST, 
    GET,
    newFetch 
} from '../../../../../helpers/fetch'
import ToastUtil from "../../../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../../../components/SweetAlert";

const Reminder = ({ history }) => {
    const [secondRollCall, setSecondRollCall] = useState('')

    const rollCallHandler = e => setSecondRollCall(e.target.value)

    const submitReminderHandler = async e => {
        e.preventDefault()
        if (await AlertService.confirm("", 'Are you sure you want to update 2nd roll call?')) {
            const api_path = '/admin/update_setting/1'
            const data = {
                value: secondRollCall
            }
            let response = await newFetch(POST, api_path, data) 
            if (response.success) ToastUtil.success(response.message)
        }
    }

    const fetchGeneralSettings = async () => {
        let api_path = `/admin/setting/1`
        let response = await newFetch(GET, api_path)
        response.success && setSecondRollCall(response.data.value)
    }
    
    useEffect(() => {
        fetchGeneralSettings()
    }, []);

    return (
        <form onSubmit={e => submitReminderHandler(e)} className="d-flex flex-column">
            <div className="p-4 d-flex flex-column">
                <h5 className="mb-4 pb-2">Reminder</h5>
                <div className="mb-2">
                    <label htmlFor="second_roll_call">Second Roll Call</label>
                    <select
                        name="second_roll_call"
                        id="second_roll_call"
                        className="form-select"
                        value={secondRollCall}
                        onChange={ e => rollCallHandler(e) }>
                        <option value="0">1.5-Hour Notification</option>
                        <option value="1">2-Hour Notification</option>
                    </select>
                </div>
            </div>
            <div style={{
                height: '4.5rem',
            }} className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4">
                <button type="submit" className="btn btn-brand ms-3" style={{width:'12rem'}}>Save changes</button>
            </div>
        </form>
    )
}

export default withRouter(Reminder)